import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    vehicles: [],
    vehicleTypes: [],
    contractors: [],
    //FORM PAGES VALUES
    listView: false,
    sortBy: "",
    filterBy: "",
    contractor: "",
    loadingVehicles: false,
    loadingVehicleTypes: false,
    loadingContractors: false,
    showDetails: false,
    showInactive: false,
    selectedRecordType: 'Active'

  },
  mutations: Mutations,
  actions: {
    resetForm(context) {
      context.commit('modifyContractor', "")
      context.commit('modifyVehicle', "")
      context.commit('modifyVehicle', "")
      context.commit('modifySite', "")
      context.commit('resetTrips')
    },
    reset(context) {

    }
  },
  getters: {
    getVehicles: state => state.vehicles
  }
}